import type { Principal } from '@cerbos/core';
import { ANY_ID } from '@skynet/authz-core';
import { UINavigationCommands } from './types';

interface CheckResourceClient {
  checkResource(request: {
    principal: Principal;
    resource: { kind: string; id: string };
    actions: string[];
  }): Promise<{ allowedActions(): string[] }>;
}

/**
 * Fetches navigation permissions from Cerbos for the given principal.
 * Designed for use outside React (e.g. route loaders) where the Cerbos
 * context is not available. The caller is responsible for dispatching
 * the result to the store.
 *
 * @param client - Cerbos HTTP client instance
 * @param principal - The authenticated principal
 * @param actions - The navigation action names to check
 * @returns The list of allowed navigation action names
 */
export const fetchNavigationPermissions = async (
  client: CheckResourceClient,
  principal: Principal,
  actions: string[],
): Promise<string[]> => {
  const resource = await client.checkResource({
    principal,
    resource: { kind: UINavigationCommands.UINavigation, id: ANY_ID },
    actions,
  });
  return resource.allowedActions();
};
